import http, { Http } from '@/lib/http';
import { OrderPayment, PreviewUpdatedScheduleResponse, ScheduleChanges } from '../types';
import { getScheduleChangesPayload } from './helpers';

type Params ={
  orderId: string;
  projectId: string;
  scheduleStaticIdentifier: string;
  originalSchedule: OrderPayment[];
  changes: ScheduleChanges;
}

function previewUpdatedScheduleCtor(http: Http) {
  return async (params: Params, signal?: AbortSignal): Promise<PreviewUpdatedScheduleResponse> => {
    const {
      projectId,
      orderId,
      scheduleStaticIdentifier,
      originalSchedule,
      changes,
    } = params;

    const { data } = await http.post(`/projects/${projectId}/schedules/${orderId}/preview`, {
      updates: getScheduleChangesPayload(originalSchedule, changes),
      scheduleStaticIdentifier,
    }, {
      signal,
    });

    return data;
  };
}

export const previewUpdatedSchedule = previewUpdatedScheduleCtor(http);
